import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[mapHost]',
})
export class MapHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
